import { whitelabelAncillariesSelector } from "ancillaries/store/whitelabelAncillaries/selectors";
import { createTrackingUtils } from "../index";
import { UIOrder } from "@flights/types";
import useContextName from "hooks/useContextName";
import useUserAgent from "hooks/useUserAgent";
import { useSelector } from "react-redux";

import { getOrderUtils } from "utils/getOrderUtils";
import { getNoOfAdults, getNoOfChildren } from "store/order/selectors";

const utils = createTrackingUtils({
  name: "flights_ace_web_lounge_access_post_booking",
  defaultStage: 1,
  stages: {
    all_users_on_pb: 1,
    desktop: 2,
    mobile: 3,
    one_way: 4,
    round_trip: 5,
    single_traveller: 6,
    traveller_with_kids: 7,
    usd_link: 8,
    non_usd_link: 9
  },
  goals: {
    lounge_access_banner_shown: 1,
    lounge_button_clicked: 2,
    od_page_viewed: 3
  },
  goalsWithValue: []
});

export function useTrackLoungeAccessOnPB(order: UIOrder) {
  const { isRoundTrip, isOneWay } = getOrderUtils(order);
  const { isMobile } = useUserAgent();
  const contextName = useContextName();
  const noOfAdults = useSelector(getNoOfAdults);
  const noOfChildren = useSelector(getNoOfChildren);
  const whitelabelAncillaries = useSelector(whitelabelAncillariesSelector);
  const ancillaryData = whitelabelAncillaries?.whitelabelAncillaries?.find((current) => {
    return current.ancillary === "loungeAccess";
  });

  const isAncillaryEligible = !!ancillaryData;

  if (isAncillaryEligible) {
    utils.stages.all_users_on_pb();

    if (ancillaryData.cta.link.includes("BOO-113")) {
      utils.stages.usd_link();
    } else {
      utils.stages.non_usd_link();
    }

    if (contextName === "pb_order_details") {
      utils.goals.od_page_viewed();
    }

    if (isMobile) {
      utils.stages.mobile();
    } else {
      utils.stages.desktop();
    }

    if (isOneWay) {
      utils.stages.one_way();
    } else if (isRoundTrip) {
      utils.stages.round_trip();
    }

    if (noOfAdults === 1) {
      utils.stages.single_traveller();
    }
    if (noOfChildren && noOfChildren > 0) {
      utils.stages.traveller_with_kids();
    }
  }
}
export default utils;
